import React, { FC } from 'react';
import Form from 'components/Form';

import { LemsipPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Lemsip: FC<LemsipPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Lemsip;
